import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { TenantService, BUSINESS_TYPE_URL_SEGMENT } from '../tenant/tenant.service';

export const businessGuard: CanActivateFn = (route, state) => {
  const tenantService = inject(TenantService);
  const router = inject(Router);

  // If client details are not loaded in signals, attempt to load them from cache first
  if (!tenantService.clientDetail()) {
    const loaded = tenantService.loadCachedConfig();
    if (!loaded) {
      // Not logged in or no context, let authGuard handle it or redirect to login
      return router.createUrlTree(['/login']);
    }
  }

  const businessType = tenantService.businessType();
  const currentPath = state.url;

  // The correct URL segment for this client's industry (e.g. 'retail', 'mobile', 'pharmacy')
  const correctSegment = BUSINESS_TYPE_URL_SEGMENT[businessType] ?? 'retail';

  // 1. Root redirect rule — redirect to the correct domain home
  if (currentPath === '/' || currentPath === '') {
    return router.createUrlTree([`/${correctSegment}`]);
  }

  // 2. Strict domain boundary rules — prevents cross-domain access
  //    Iterates all registered domains; works for any future vertical automatically
  for (const [domain, segment] of Object.entries(BUSINESS_TYPE_URL_SEGMENT)) {
    if (currentPath.startsWith(`/${segment}`) && domain !== businessType) {
      return router.createUrlTree([`/${correctSegment}`]);
    }
  }

  // Allow access
  return true;
};
